import React from "react";
import { TableRow, TableCell, withStyles } from "@material-ui/core";
import StyledToolTip from "../../../../common/StyledToolTip";
import { formatPhone } from "../../../../modules/Dispatch/utils/utils";

const styles = {
  driverStatusHeadHeight: {
    height: "24px",
    color:"#444444"
  },
  driverStatusHeaderCell: {
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: "10px",
    fontWeight: 600,
  },
  customerName: {
    float: "left",
    paddingLeft: "10px",
    lineHeight: "17px",
    width: "55%",
    textOverflow: "ellipsis",
    wordBreak: "break-all",
  },
  contactNumber: {
    float: "right",
    fontSize: 12,
    paddingRight: "10px",
  },
};

const Contact = ({ theme, classes, name, phoneNumber }) => {
  if (!(name || phoneNumber)) {
    return null;
  }
  const formattedPhoneNumber = formatPhone(phoneNumber);
  return (
    <TableRow
      className={`${classes.driverStatusHeadHeight} driverStatusRow-${theme}`}
    >
      <TableCell
        colSpan={2}
        className={`${classes.driverStatusHeaderCell} driverStatusRow-${theme} tableCellValue`}
      >
        <div className={classes.customerName}> {name} </div>
        <StyledToolTip title={formattedPhoneNumber}>
          <span className={classes.contactNumber}>{formattedPhoneNumber}</span>
        </StyledToolTip>
      </TableCell>
    </TableRow>
  );
};

export default withStyles(styles)(Contact);
